import { Config } from './types/config';

const config: Config = {
  middlewareHmacToken:
    process.env.AIRFLOW_WEBHOOK_TOKEN || 'e4f73d84-5864-11ee-8c99-0242ac120002',
  integrations: [
    {
      shortName: 'bamboohr',
      name: 'BambooHR',
      category: 'Human Resource',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/bamboohr.logo.svg'
      },
      descriptionTextArray: [
        'This Integration syncs employee data from BambooHR to Replicon.',
        'When a new employee record is created in BambooHR a corresponding user is created in Replicon',
        'When an employee status is set to Inactive with/without termination date in BambooHR, the user profile in Replicon will be disabled & the end date will be updated if termination date is specified'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'servicenow',
      name: 'Service Now',
      category: 'Incident Management',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/servicenow.logo.svg'
      },
      descriptionTextArray: [],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'namely',
      name: 'Namely',
      category: 'HRMS/Payroll',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/namely.logo.svg'
      },
      descriptionTextArray: [],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'sagefinancials',
      name: 'Sage Financials',
      category: 'Accounting/Invoicing',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/sagefinancials.logo.svg'
      },
      descriptionTextArray: [],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'quickbooks',
      name: 'QuickBooks Online',
      category: 'Accounting',
      isOauth2: true,
      basicAuth: false,
      appScope: ['TENANT'],
      image: {
        src: 'logos/quickbooks.logo.svg'
      },
      descriptionTextArray: [
        'New Customer created in QuickBooks Online will create client in Replicon',
        'Sync new invoice in Replicon to QuickBooks Online - V2',
        'When a invoice is updated in QuickBooks Online, update invoice status in Replicon - V2'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'sageintacct',
      name: 'Sage Intacct',
      category: 'Accounting/Invoicing',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/sageintacct.logo.svg'
      },
      descriptionTextArray: [],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'replicon',
      name: 'Custom On-Demand Integrations',
      category: 'Custom',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/replicon.logo.svg'
      },
      descriptionTextArray: [],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'salesforce',
      name: 'Salesforce',
      category: 'Project Management',
      isOauth2: true,
      basicAuth: false,
      appScope: ['TENANT'],
      image: {
        src: 'logos/salesforce.logo.svg'
      },
      descriptionTextArray: [
        'When an account is created or updated in Salesforce the data is automatically synced to Replicon',
        'When an opportunity is created or updated in Salesforce, the data is automatically synced to Replicon',
        'When configuring the Integration you can choose the type of accounts and opportunities that meet specific type, stage and/or probability to be synced to Replicon so that only required accounts and opportunities are synced.'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'xero',
      name: 'Xero',
      category: 'Accounting',
      isOauth2: true,
      basicAuth: false,
      appScope: ['TENANT'],
      image: {
        src: 'logos/xero.logo.svg'
      },
      descriptionTextArray: [
        'When a new client is created in Replicon it gets synced to Xero as contact',
        'When a contact is created or updated in Xero it gets synced as client in Replicon',
        'Sync new invoice in Replicon to Xero',
        'Sync Xero "Billed" invoice status to Replicon',
        'Sync Xero "Paid" invoice status to Replicon'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'zendesk',
      name: 'Zendesk',
      category: 'Accounting',
      isOauth2: true,
      basicAuth: false,
      appScope: ['TENANT'],
      image: {
        src: 'logos/zendesk.logo.svg'
      },
      descriptionTextArray: [
        'New/Updated Organizations in Zendesk will Create/Update Clients in Replicon',
        'New/Updated Tickets in Zendesk will Create/Update Projects in Replicon'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'jira',
      name: 'Jira',
      category: 'Project Management',
      isOauth2: true,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/jira.logo.svg'
      },
      descriptionTextArray: [
        'Replicon Jira integration allows you to easily transfer employees, issues, and projects between Replicon and Jira. This integration supports:',
        'Transfer of users from Replicon to Jira, eliminating the need for duplicate data entry',
        'Transfer of projects and issues from Jira to Replicon, so you can use Replicon to plan work, track progress, and bill clients'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    },
    {
      shortName: 'computerease',
      name: 'ComputerEase',
      category: 'Construction Management',
      isOauth2: false,
      basicAuth: true,
      appScope: ['TENANT'],
      image: {
        src: 'logos/computerease.logo.svg'
      },
      descriptionTextArray: [
        'ComputerEase integration allows seamless data synchronization between ComputerEase construction management system and Replicon.',
        'Import users from ComputerEase to Replicon to maintain consistent employee records across systems',
        'Transfer projects from ComputerEase to Replicon for accurate time tracking and project management',
        'Import timesheet data from Replicon to ComputerEase for comprehensive time and billing analysis'
      ],
      repliconDocumentationLink: '',
      polarisDocumentationLink: ''
    }
  ]
};

export default config;
